import React from "react";
import "../assets/styles/tools.css";
const tools = [
  { name: "vscode" },
  { name: "github" },
  { name: "netlify" },
  { name: "heroku" },
];
const Tools = () => {
  return (
    <div className="my_skils_tools_container">
      <div className="my_skils_tools_content">
        {tools.map((item, index) => {
          return (
            <div className="my_tools_item_container" key={index}>
              <div className="tools_logo">
                <p>{item.name.slice(0, 3)}</p>
              </div>
              <p className="my_tools_item_item_name">{item.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tools;
